import { useEffect } from 'react';

import type { UseAddEditSupplierEffectsProps } from '@app/pages/Warehouses/Suppliers/components/AddEditSupplier/types';

export const useAddEditSupplierEffects = ({
  initForm,
  skipForm,
}: UseAddEditSupplierEffectsProps) => {
  useEffect(() => {
    initForm();

    return skipForm;
  }, [initForm, skipForm]);
};
